export default __webpack_public_path__ + "static/media/home-log.bd5302de.svg";